import axios from '@/plugins/axios'

function store(data) {
  return axios.post('/service-cost-reports', data)
    .then(response => {
      return response.data
    })
}

function update(data, id) {
  return axios.patch(`/service-cost-reports/${id}`, data)
    .then(response => {
      return response.data
    })
}

export default {
  fetch(params) {
    return axios.get('/service-cost-reports', { params: params })
      .then(response => {
        return response.data
      })
  },
  save(data, id) {
    if (id) return update(data, id)

    return store(data)
  },
  find(id) {
    return axios.get(`/service-cost-reports/${id}`)
      .then(response => {
        return response.data
      })
  },
  findLastForYacht(yachtId) {
    return axios.get(`/yachts/${yachtId}/last-cost-report`)
      .then(response => response.data)
  },
  fetchServiceTasksWithCosts(yachtId, dateFrom, dateTo, currency) {
    return axios.get(`/yachts/${yachtId}/service-task-costs`, {
      params: {
        date_from: dateFrom,
        date_to: dateTo,
        currency: currency
      }
    }).then(response => response.data)
  },
  destroy(id) {
    return axios.delete(`/service-cost-reports/${id}`).then(response => response.data)
  }
}
